var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../di";
import { HistoricalFulfillmentTime } from "../ordering";
import { POrderDetailsProvider } from "./POrderDetails";
import { PRestaurant } from "./PRestaurant";
import { t, translate } from "../I18n";
let PHistoricalFulfillmentTime = class PHistoricalFulfillmentTime {
    constructor(historicalFulfillmentTime, orderDetailsProvider, restaurant) {
        this.historicalFulfillmentTime = historicalFulfillmentTime;
        this.restaurant = restaurant;
        this.orderDetails = orderDetailsProvider.orderDetails;
        makeAutoObservable(this);
    }
    get restaurantId() {
        return this.restaurant.id.value;
    }
    get hasData() {
        return this.historicalFulfillmentTime.hasData;
    }
    get estimatedRange() {
        if (this.orderDetails.type !== "Online") {
            return null;
        }
        const range = this.historicalFulfillmentTime.getEstimatedRange(this.orderDetails.fulfillmentMethodType);
        if (range === null) {
            return null;
        }
        // We want to always show a range, because a single value
        // can be perceived as a guarantee
        if (range.low === range.high) {
            range.high += 10;
        }
        return range;
    }
    get label() {
        if (this.estimatedRange === null) {
            return null;
        }
        return translate(t.generic.duration.minutes.short, {
            count: `${this.estimatedRange.low}-${this.estimatedRange.high}`,
        });
    }
    get analyticsData() {
        if (this.orderDetails.type !== "Online") {
            return null;
        }
        const method = this.orderDetails.fulfillmentMethodType;
        if (method === null) {
            return null;
        }
        if (this.estimatedRange === null) {
            return null;
        }
        return {
            fulfillmentMethodType: method,
            high: this.estimatedRange.high,
            low: this.estimatedRange.low,
        };
    }
};
PHistoricalFulfillmentTime = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof HistoricalFulfillmentTime !== "undefined" && HistoricalFulfillmentTime) === "function" ? _a : Object, typeof (_b = typeof POrderDetailsProvider !== "undefined" && POrderDetailsProvider) === "function" ? _b : Object, typeof (_c = typeof PRestaurant !== "undefined" && PRestaurant) === "function" ? _c : Object])
], PHistoricalFulfillmentTime);
export { PHistoricalFulfillmentTime };
